import React from 'react';

const Loading = () => (
  <div className="w-lightbox-spinner" />
);

export default Loading;
